<template>
  <div :id="id" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="buy_modelLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal m-3 m-md-4" style="background: rgba(25, 25, 25, 0.85); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; box-shadow: 0 10px 40px rgba(0,0,0,0.5); position: relative;">
        <!-- Close (X) Icon -->
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="$emit('cancel')" style="position: absolute; right: 16px; top: 16px; z-index: 10; opacity: 0.6; text-shadow: none; outline: none; background: transparent; border: none;">
          <span aria-hidden="true" style="font-size: 24px;">&times;</span>
        </button>

        <div class="modal-body text-center p-4 p-md-5">
          
          <!-- Icon -->
          <div class="mb-4">
            <div style="width: 64px; height: 64px; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin: 0 auto; border: 1px solid rgba(255,110,199,0.3);"
                 :style="isDestructive ? 'background: rgba(255, 75, 75, 0.1); border-color: rgba(255, 75, 75, 0.3);' : 'background: linear-gradient(135deg, rgba(255, 110, 199, 0.15), rgba(249, 168, 38, 0.15));'">
              <i class="fa" 
                 :class="iconClass ? iconClass : (isDestructive ? 'fa-trash' : 'fa-shopping-cart')" 
                 :style="isDestructive ? 'font-size: 26px; color: #ff4b4b;' : 'font-size: 26px; color: #ff6ec7;'"></i>
            </div>
          </div>
          
          <div class="my-2">
            <h4 class="font-size-22 text-white font-weight-bold mb-2" v-if="title">{{ title }}</h4>
            <p class="font-size-15 text-muted mb-4" style="line-height: 1.5;"> {{ text }}</p>
            
            <div class="d-flex justify-content-center mt-3">
              <button type="button" @click="$emit('confirm')"
                      class="btn px-4 font-weight-bold border-0 font-size-15"
                      style="border-radius: 12px; min-width: 200px;"
                      :class="buttonColor === 'btn-success' ? 'btn-premium' : (buttonColor.includes('btn-danger') || buttonColor.includes('delete') ? 'btn-destructive' : buttonColor)"
                      :disabled="isLoading"
                      data-dismiss="modal">
                <i v-if="isLoading" class="fa fa-spinner fa-spin mr-2"></i>
                {{ confirmBtnTxt }}
              </button>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelBasic",
  props: {
    id: {
      type: String,
      default: 'basic_model'
    },
    title: String,
    text:  String,
    buttonColor:  {
      type: String,
      default: 'btn-success' //btn-danger-closefriend
    },
    confirmBtnTxt: {
      type: String,
      default: 'Confirm'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    iconClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDestructive() {
      return this.buttonColor.includes('danger') || this.buttonColor.includes('delete');
    }
  },
  methods: {
    show() {
      $(`#${this.id}`).modal();
    },
    hide() {
      $(`#${this.id}`).modal('hide');
    }
  }
}
</script>

<style scoped>
.btn-premium {
  background: linear-gradient(135deg, #ff6ec7, #f9a826);
  color: #fff !important;
  transition: all 0.2s ease;
}
.btn-premium:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 110, 199, 0.4);
}

.btn-destructive {
  background: #ff4b4b;
  color: #fff !important;
  transition: all 0.2s ease;
  box-shadow: 0 4px 15px rgba(255, 75, 75, 0.3);
}
.btn-destructive:hover {
  background: #ff3333;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 75, 75, 0.4);
}
</style>
